import React from 'react'
import { ThemeProvider } from './Providers/Themes/Themes.jsx'
import {
  GameModeProvider,
  useGameMode,
} from './Providers/GameModes/GameModes.jsx'
import { GameStatsProvider } from './Providers/GameStats/GameStats.jsx'
import { GameStateProvider } from './Providers/GameStates/GameState.jsx'
import Keyboard from './components/Keyboard/Keyboard.jsx'
import GameBoard from './components/GameBoard/GameBoard.jsx'
import Header from './components/Header/Header.jsx'
import { SnackbarProvider } from 'notistack'

const GameSession = () => {
  const { gameMode } = useGameMode()

  return (
    <GameStatsProvider key={gameMode}>
      <GameStateProvider>
        <Header />
        <GameBoard />
        <Keyboard />
      </GameStateProvider>
    </GameStatsProvider>
  )
}

const App = () => {
  return (
    <ThemeProvider>
      <SnackbarProvider maxSnack={3} autoHideDuration={2000}>
        <GameModeProvider>
          <GameSession />
        </GameModeProvider>
      </SnackbarProvider>
    </ThemeProvider>
  )
}

export default App
